jQuery(function($) {
    // Vars //
    var $body = $('body');
    var $window = $(window);
    var $header = $('header');
    var tour_date_picker;

    // Functions
    mobileMenuResizer();
    sliderSetup();
    featureProductSliderSetup();
    logoSliderBlockSetup();
    iconSliderBlockSetup();
    staggeredImageCtasSetup();
    galleryBlockSetup();
    accommodationBlockSetup();
    itineraryBlockSetup();
    toursBlockSetup();
    tourGuidesBlockSetup();
    reviewsBlockSetup();
    openTourModalFormSetup();
    initBookNowFlatpickr();

    jQuery(document).on('gform_page_loaded', function(event, form_id, current_page){
        initBookNowFlatpickr();
        renderBookingSummary();

        if (tourBookNowDates.tour_dates === 'choose') {
            updateTourDatePeriodPricing();
        }
    });

    // add tour name param to enquiry button onsingle tour pages
    if ($('body').hasClass('single-tour')) {
        $('a.wp-block-button__link:contains("Enquire Now")').each(function(index){
            var _href = $(this).attr("href");
            var page_title = document.title;
            page_title = page_title.substring(0, page_title.indexOf(" | Luxury Women"));
            var tour_title = page_title;
            $(this).attr("href", _href+'?tour_enquiry='+encodeURIComponent(tour_title));
        });
    }

    // Init inline Datepicker for Book Now form
    // references tourBookNowDates inline script that pulls data from current Tour post
    function initBookNowFlatpickr() {
        
        if ((typeof tourBookNowDates === 'undefined' || tourBookNowDates === null)) { return; }

        // Tours with fixed booking date
        if (tourBookNowDates.tour_dates === 'fixed') {
            $args = {
                inline: true,
                dateFormat: "d/m/Y",
                mode: "range",
                minDate: tourBookNowDates.tour_start_date,
                maxDate: tourBookNowDates.tour_end_date,
                defaultDate: [tourBookNowDates.tour_start_date, tourBookNowDates.tour_end_date],
                onChange: function(selectedDates, dateStr, instance) {
                    instance.setDate([tourBookNowDates.tour_start_date, tourBookNowDates.tour_end_date]);
                },
                onDayCreate: function(dObj, dStr, fp, dayElem) {
                    // Utilize dayElem.dateObj, which is the corresponding Date 
                    var dd = String(dayElem.dateObj.getDate()).padStart(2, '0');
                    var mm = String(dayElem.dateObj.getMonth() + 1).padStart(2, '0'); // January is 0!
                    var yyyy = dayElem.dateObj.getFullYear();
                    var date = dd + '/' + mm + '/' + yyyy;

                    var formatted_tour_price = tourBookNowDates.tour_price_twin_share.replace(',','');
                    formatted_tour_price = Number(formatted_tour_price);
                    formatted_tour_price = formatted_tour_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    if (date == tourBookNowDates.tour_start_date) {
                        dayElem.innerHTML = '<span class="date-has-price">'+dayElem.innerHTML+'<br/><span class="price">$'+formatted_tour_price+'</span></span>';
                    }
                },
            }
        }

        // Tours with flexible booking dates
        if (tourBookNowDates.tour_dates === 'choose') {
            $args = {
                inline: true,
                dateFormat: "d/m/Y",
                enable: [
                    function(date) {
                        var is_valid_date = false;
                        var today = new Date();

                        // disable date if in the past
                        if (date.getTime() < today.getTime()) { return false; }

                        // compare date to date range options
                        tourBookNowDates.tour_date_ranges.forEach(function (item, index) {
                            var start = convertToDate(item.period_start_date);
                            var end = convertToDate(item.period_end_date);

                            // if date is within date range
                            if (date >= start && date <= end) {
                                is_valid_date = true;
                            }
                        });

                        return is_valid_date;
                    }
                ],
                onDayCreate: function(dObj, dStr, fp, dayElem) {
                    // Utilize dayElem.dateObj, which is the corresponding Date 
                    var formatted_tour_price;
                    tourBookNowDates.tour_date_ranges.forEach(function (item, index) {
                        var start = convertToDate(item.period_start_date);
                        var end = convertToDate(item.period_end_date);
                        if (dayElem.dateObj >= start && dayElem.dateObj <= end) {
                            formatted_tour_price = item.period_price_twin_share.replace(',','');
                            formatted_tour_price = Number(formatted_tour_price);
                            formatted_tour_price = formatted_tour_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    });
                    if (formatted_tour_price) {
                        dayElem.innerHTML = '<span class="date-has-price">'+dayElem.innerHTML+'<br/><span class="price">$'+formatted_tour_price+'</span></span>';
                    }
                },
                onChange: function(selectedDates, dateStr, instance) {
                    updateTourDatePeriodPricing();
                }
            }
        }

        tour_date_picker = $('.tour-start-date input').flatpickr($args);
    }

    // Update tour pricing based on selected date
    function updateTourDatePeriodPricing(){
        tourBookNowDates.tour_date_ranges.forEach(function (item, index) {
            var start = convertToDate(item.period_start_date);
            var end = convertToDate(item.period_end_date);
            var selectedDates = tour_date_picker.selectedDates;

            // if date is within date range
            if (selectedDates[0] >= start && selectedDates[0] <= end) {
                //console.log('period start: '+start);
                //console.log('period end: '+end);

                // update twin share price
                var period_price_twin_share = Number(item.period_price_twin_share.replace(/\$|,/g, ''));
                $('#input_9_97').val(period_price_twin_share);
                //console.log('period_price_twin_share: '+period_price_twin_share);
                // update single supplement
                var period_price_single_supplement = Number(item.period_price_single_supplement.replace(/\$|,/g, ''));
                $('#input_9_98').val(period_price_single_supplement);
                //console.log('period_price_single_supplement: '+period_price_single_supplement);

                //console.log($('#input_9_89 option'));

                // update single supplement price in single room select
                $('#input_9_89 option').each(function( index ) {
                    // Skip first 'None' option
                    if (index == 0) { return true; }

                    // calc total
                    single_room_single_supp_total = period_price_single_supplement * index;

                    // Replace single supplement price
                    $(this).text(index+' (+$'+single_room_single_supp_total+')');
                    //console.log( index + ": " + $( this ).text() );
                });
            }
        });
    }

    // Render the Booking Summary for the Book Now form
    function renderBookingSummary() {
        var summary = '';
        var total = 0;

        var tourTitle = $('#input_9_96').val();
        var startDate = $('#input_9_76').val();

        var dateObj = new Date(startDate);

        var tourPricePPDouble = Number($('#input_9_97').val().replace(/\$|,/g, '')); // Tour price per person Twin Share (Double room)
        var tourSingleSupplement = Number($('#input_9_98').val().replace(/\$|,/g, ''));
        var tourPricePPSingle = tourPricePPDouble + tourSingleSupplement;

        // console.log('tourPricePPDouble: '+ tourPricePPDouble);
        // console.log('tourSingleSupplement: '+ tourSingleSupplement);
        // console.log('tourPricePPSingle: '+ tourPricePPSingle);

        // double rooms
        if ($('#input_9_81').val() === 'solo') {
            var doubleRooms = 1;
            var doubleTravellers = 1;
        } else {
            var doubleRooms = Number($('#input_9_81').val());
            var doubleTravellers = doubleRooms * 2;
        }
        // single rooms
        var singleRooms = Number($('#input_9_89').val());
        // totals
        var totalTravellers = doubleTravellers + singleRooms;
        var doubleTotal = doubleTravellers * tourPricePPDouble;
        var singleTotal = singleRooms * tourPricePPSingle;

        // console.log('totalTravellers: '+ totalTravellers);

        // console.log('doubleRooms: '+ doubleRooms);
        // console.log('singleRooms: '+ singleRooms);
        // console.log('doubleTravellers: '+ doubleTravellers);
        // console.log('totalTravellers: '+ totalTravellers);
        // console.log('doubleTotal: '+ doubleTotal);
        // console.log('singleTotal: '+ singleTotal);
        
        total = doubleTotal + singleTotal;

        var roomUpgradeValuePP = Number($('#input_9_87').val());
        var roomUpgradeLabel = $("#input_9_87 option:selected").text();

        var roomUpgradeTotal = roomUpgradeValuePP * totalTravellers;
        total = total + roomUpgradeTotal;

        // console.log('roomUpgradeValuePP: '+ roomUpgradeValuePP);
        // console.log('roomUpgradeTotal: '+ roomUpgradeTotal);

        var optionalExtras = $('#field_9_88 input:checked'); // Optional extras
        var extrasTotal = 0;

        if (optionalExtras.length > 0) {
            $(optionalExtras).each(function(index, element) {
                var extraPricePP = Number($(element).val());
                var extraPriceTotal = extraPricePP * totalTravellers;

                extrasTotal = extrasTotal + extraPriceTotal;
                total = total + extraPriceTotal;
            });
        }

        // console.log('optionalExtras: '+ optionalExtras);
        // console.log('extrasTotal: '+ extrasTotal);

        // console.log('total: '+ total);

        // Update Deposit Quantity
        $('.booking-deposit .ginput_quantity').val(totalTravellers);
        $('.booking-deposit .ginput_quantity_label').html('x');

        // Construct booking summary HTML markup
        summary += '<p><strong>'+tourTitle+'</strong></p>';
        summary += '<p>'+startDate+'</p>';

        // Double rooms
        if (doubleRooms > 0) {
            summary += '<p><strong>Package(s)</strong> <span class="summary-total">$'+numberWithCommas(doubleTotal)+'</span></p>';
            summary += '<p>'+doubleTravellers +' @ $'+tourPricePPDouble+'pp'+'</p>';
        }

        // Single rooms
        if (singleRooms > 0) {
            summary += '<p><strong>Single Package(s)</strong> <span class="summary-total">$'+numberWithCommas(singleTotal)+'</span></p>';
            summary += '<p>'+singleRooms +' @ $'+tourPricePPSingle+'pp</p>';
        }

        // Room Upgrades
        if (roomUpgradeTotal) {
            summary += '<p><strong>Room Upgrades</strong> <span class="summary-total">$'+numberWithCommas(roomUpgradeTotal)+'</span></p>';
            summary += '<p>'+totalTravellers+' @ '+roomUpgradeLabel+'</p>';
        }

        // Extras
        if (extrasTotal) {
            summary += '<p><strong>Extras</strong> <span class="summary-total">$'+numberWithCommas(extrasTotal)+'</span></p>';

            if (optionalExtras.length > 0) {
                summary += '<p>';
                $(optionalExtras).each(function(index, element) {
                    var label = $(element).parent().find('label').text();
                    summary += totalTravellers+' @ '+label;
                });
                summary += '</p>';
            }
        }

        summary += '<hr/>';
        summary += '<p><strong>Total</strong> <span class="summary-total">AUD $'+numberWithCommas(total.toFixed(2))+'</span></p>';

        // HTML summary
        $('.book-now-form-summary-js').html(summary);

        // Summary submitted with form
        // content wont set without waiting - likely because TinyMCE re-initilises/clears itself 
        setTimeout(function() { 
            tinyMCE.get('input_9_113').setContent(summary);
            //console.log(tinyMCE.get('input_9_113').getContent());
        }, 1000);
    }

    // Onclick Events
    $body
        .on('click', '.js-mobile-trigger', function (e) {
            e.preventDefault();
            var $trigger = $(this);
            // changed to apply class to all mobile triggers so I can have multiple on page
            var $mobileTriggers = $('.js-mobile-trigger');
            if ($mobileTriggers.hasClass('active')) {
                $mobileTriggers.removeClass('active');
                $body.removeClass('hamburger-menu-active');
                $body.removeClass('no-scroll');
            }
            else {
                $mobileTriggers.addClass('active');
                $body.addClass('hamburger-menu-active');
                $body.addClass('no-scroll');
            }
        })
        .on('click', '.js-footer-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.footer-accordion');
            var $accordionContent = $accordion.find('.footer-accordion__content');
            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $accordionContent.slideUp(350);
            } else {
                $accordion.addClass('active');
                $accordionContent.slideDown(350);
            }
        })
        .on('click', '.js-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.accordion');
            var $accordionContent = jQuery($accordion).find('.accordion__content');
            if ($accordion.hasClass('open')) {
                $accordion.removeClass('open');
                $accordionContent.slideUp();
            } else {
                $accordion.addClass('open');
                $accordionContent.slideDown();
            }
        })
        // mobile menu dropdown handling
        .on('click', '.menu-item-dropdown-toggle', function(e) {
            e.preventDefault();
            var $this = $(this);
            $navItem = $this.closest('.nav-list__item');
            $dropdownMenu = $navItem.children('.nav-list__dropdown');
            $navItem.toggleClass('submenu-active');

            $dropdownMenu.toggleClass('active');

        })
        // when dropdown menus have headers on mobile (see explorate, veto for examples)
        .on('click', '.dropdown-header-back', function(e) {
            e.preventDefault();
            var $this = $(this);
            $this.closest('.nav-list__item').removeClass('submenu-active');
            $this.closest('.nav-list__dropdown').removeClass('active');
        })
        // tabbed accordions
        .on('click', '.js-tab-trigger', function (e) {
            e.preventDefault();
            var $tabContentID = $(this).data('tab-content-id');
            var $tabContent = $('[data-tab-id="' + $tabContentID + '"]');

            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $($tabContent).removeClass('open');
                $($tabContent).hide();
            } else {
                $(this).addClass('open');
                $(".js-tab-trigger").removeClass('open');
                $(".tab-content").removeClass('open');
                $tabContent.show();
            }

            // tab button open classes
            // reset all tabs
            $(".js-tab-trigger").removeClass('open');
            $(".js-tab-trigger").removeClass('btn-primary');
            $(".js-tab-trigger").addClass('btn-light-c');

            // add open classes to current tab
            $(this).removeClass('btn-light-c');
            $(this).addClass('open');
            $(this).addClass('btn-primary');

            // tab content open classes
            $(".tab-content").removeClass('open');
            $($tabContent).addClass('open');

            // show and hide tabs
            $(".tab-content").hide();
            $($tabContent).show();
        });
    ;

    var hours = 24; // Reset when storage is more than 24hours
    var now = Date.now();
    var newsletterPopupCookie = localStorage.getItem('newsletterPopupCookie');

    if (newsletterPopupCookie == null || newsletterPopupCookie == '') {
        localStorage.setItem('newsletterPopupCookie', now);

        setTimeout(function () {
            $('#newsletterModal').modal('show');
        }, 10000); // for 10 second delay 
    } 
    else if (now - newsletterPopupCookie > hours * 60 * 60 * 1000) {
        localStorage.clear();
    }

    // Resize Functions //
    var resizeThreshold;
    $(window).on('resize', function () {
        if (resizeThreshold) {
            clearTimeout(resizeThreshold);
        }

        resizeThreshold = setTimeout(function () {
            setTimeout(function () {
                // Functions
                mobileMenuResizer();
                sliderSetup();
                featureProductSliderSetup();
                logoSliderBlockSetup();
                iconSliderBlockSetup();
                staggeredImageCtasSetup();
                galleryBlockSetup();
                accommodationBlockSetup();
                itineraryBlockSetup();
                toursBlockSetup();
            }, 100);
        }, 200);
    });

    // Convert a "dd/MM/yyyy" string into a Date object
    function convertToDate(dateString) {
        var d = dateString.split("/");
        var dat = new Date(d[2] + '/' + d[1] + '/' + d[0]);
        return dat;
    }

    // Resolve the conflict closing modal while keeping another active
    $('#newsletterModal').on('hidden.bs.modal', function (e) {
        var modal_el = $('.modal.show');
        if(modal_el.length > 0 && !$('body').hasClass('modal-open')) {
            $('body').addClass('modal-open');
        } 
    });
});

